// extracted by mini-css-extract-plugin
export var icon = "_9m-3";
export var subtitle = "_9m-2";
export var title = "_9m-1";
export var value = "_9m-0";